export default __webpack_public_path__ + "static/media/engine-oil.e49037f6.png";